
const NotFound = () => {

  // useEffect(() => {
  //   document.title = "404";
  //   window.open("https://demo.softneta.com/", "_blank");
  // }, []);
  
  return (
  <div>
    <h1>404 - Route pending</h1>
  </div>
)};

export default NotFound;